import { Div, Icon, Text } from "atomize"
import { theme } from "../settings/config"
import { useContext, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faUser } from "@fortawesome/free-solid-svg-icons"
import { motion } from "framer-motion"
import { profileContext } from "../providers/profile.provider"
import { schoolContext } from "../providers/school.provider"
import Dropdown from "../atomize/Dropdown"
import Divider from "../atoms/Divider"
import { canSwitchDisplayedCoach, getViewableCoaches } from "../utils/func.utils"

function ProfileCoachDropdown() {
	const { coach, displayedCoachID, setDisplayedCoachID } = useContext(profileContext)
	const { getSelectedSchool, selectedSchool } = useContext(schoolContext)

	const [isOpen, setIsOpen] = useState(false)

	if (
		!displayedCoachID ||
		!canSwitchDisplayedCoach(coach, getSelectedSchool(), selectedSchool)
	)
		return null

	// solo chi si può guardare: vedere le lezioni di un collega non vuol dire
	// vedere quelle di tutti
	const coaches = getViewableCoaches(coach, getSelectedSchool(), selectedSchool)

	return (
		<>
			<motion.div
				style={{
					position: "fixed",
					right: "1rem",
					bottom: "5.25rem",
					zIndex: "1",
				}}
				whileTap={{ scale: 0.9 }}
				initial={{ opacity: 0, scale: 0 }}
				animate={{ opacity: 1, scale: 1 }}
				exit={{ opacity: 0 }}>
				<Dropdown
					w="fit-content"
					p="1.75rem 0.75rem"
					rounded="20px"
					bg="primary"
					focusBg="primary"
					direction="topright"
					borderColor={theme.colors.primary}
					focusBorderColor={theme.colors.primary}
					textColor="white"
					isOpen={isOpen}
					openSuffix={
						<Icon name="DownArrow" size="18px" m={{ l: "1rem" }} color="white" />
					}
					closeSuffix={
						<Icon name="UpArrow" size="18px" m={{ l: "1rem" }} color="white" />
					}
					onClick={() => setIsOpen(!isOpen)}
					menu={coaches.map((coachItem, i) => (
						<>
							<Text
								key={coachItem.coachID}
								p="0.75rem 1rem"
								textAlign="left"
								onClick={() => {
									setDisplayedCoachID(coachItem.coachID)
									setIsOpen(false)
								}}
								style={{ cursor: "pointer" }}>
								{coachItem.coachName === coach.coachName ? "Tu" : coachItem.coachName}
							</Text>
							{i < coaches.length - 1 && (
								<Divider
									m={{ x: "0.5rem" }}
									w="2px solid"
									borderColor={theme.colors.background}
								/>
							)}
						</>
					))}>
					<Div
						w="fit-content"
						d="flex"
						align="center"
						style={{ gap: "0.25rem" }}
						rounded="15px"
						textWeight="normal"
						bg={theme.colors.primary}>
						<FontAwesomeIcon icon={faUser} size="sm" />
						<Text textAlign="right">
							{getSelectedSchool()?.coaches[displayedCoachID]?.coachName ===
							coach.coachName
								? "Tu"
								: getSelectedSchool()?.coaches[displayedCoachID]?.coachName}
						</Text>
					</Div>
				</Dropdown>
			</motion.div>
			<Div h="5rem" pos="relative" />
		</>
	)
}

export default ProfileCoachDropdown
